import React  from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { FilePickerArchivedCaseList } from "./file-picker-archived-case-list";
import { useQuery } from "@apollo/client";
import { CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdDocument} from "../../../../../../generated";
import { Empty } from "antd";

interface FilePickerArchivedCaseListContainerProps {
  applicantId: string;
  setCaseInfo: (selectedCaseId: string, selectedCaseType: string) => void;
  applicantName: string;
  selectedTab: string;
}

export const FilePickerArchivedCaseListContainer: React.FC<
FilePickerArchivedCaseListContainerProps
> = (props) => {

  const { data, loading, error } = useQuery(CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdDocument, {
    variables: {
      id: props.applicantId
    },
    skip: !props.applicantId
  });

  const formattedData = data?.archivedCasesByApplicantId
  ?.map((item) => ({
    id: item?.id,
    caseType: item?.caseType,
    state: item?.state,
    caseName: item?.caseName,
    archivedAt: item?.archivedAt,
  })) ?? [];


  return (
    <ComponentQueryLoader
      loading={loading}
      error={error}
      hasData={formattedData.length > 0}
      hasDataComponent={<FilePickerArchivedCaseList selectedTab={props.selectedTab} cases={formattedData} setCaseInfo={props.setCaseInfo} applicantName={props.applicantName}/>}
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
